'use strict';

var _ = require('lodash');
var strategiesService = function strategiesService(restangular, elementService) {
  var strategiesData = [];
  var templates = require('../../constants/templates.json');
  var templateService = restangular.one('rules').one('strategy').one('usageCount');
  function setStrategiesData(strategies) {
    strategiesData = strategies;
  }
  function getStrategiesFromTemplate(template) {
    return strategiesData.filter(function (el) {
      return el.basis === template.basis;
    });
  }
  function getStrategyTemplates() {
    return templates;
  }
  function cleanStrategy(strategy) {
    strategy.groups.forEach(function (group) {
      group.actions = _.chain(group.actions).map(function (action) {
        return action.isValid() ? action : null;
      }).compact().value();
      group.conditions = _.chain(group.conditions).map(function (condition) {
        return condition.isValid() ? condition : null;
      }).compact().value();
    });
    strategy.groups = _.chain(strategy.groups).map(function (group) {
      return group.conditions.length || group.actions.length ? group : null;
    }).compact().value();
    return strategy;
  }
  function repopulateStrategy(strategy) {
    strategy.groups.forEach(function (group) {
      if (group.actions.length === 0) {
        group.actions.push(elementService.createAction());
      }
      if (group.conditions.length === 0) {
        group.conditions.push(elementService.createCondition());
      }
    });
    return strategy;
  }
  function copyStrategy(strategy) {
    return _.cloneDeepWith(strategy, function (val) {
      if (val && val.createCopy) {
        return val.createCopy();
      }
    });
  }
  function retrieveTemplateUsage() {
    templateService.get().then(function (usage) {
      templates.forEach(function (t) {
        t.numberOfStrategies = usage.content[t.id] || 0;
      });
    });
  }
  return {
    setStrategiesData: setStrategiesData,
    getStrategiesFromTemplate: getStrategiesFromTemplate,
    getStrategyTemplates: getStrategyTemplates,
    retrieveTemplateUsage: retrieveTemplateUsage,
    cleanStrategy: cleanStrategy,
    repopulateStrategy: repopulateStrategy,
    copyStrategy: copyStrategy
  };
};
strategiesService.$inject = ['Restangular', 'StrategyElementService'];
module.exports = strategiesService;